import { styled as muiStyled } from '@mui/material/styles'
import styled from '@emotion/styled'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { darken } from '@mui/material'
import { t } from '@lingui/core/macro'

const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
`

const InfoIcon = styled(InfoOutlined)`
  position: relative;
  margin-right: 3px;
`

const InfoText = muiStyled('span')`
  color: ${({ theme }) => darken(theme.palette.info.main, 0.75)};
`
interface Props {
  isAdmin: boolean
}

export const ApprovalRequiredText = ({ isAdmin }: Props) => {
  return (
    <Container>
      <InfoIcon color="primary" />
      {isAdmin ? (
        <InfoText>{t`Changes to data made by admins will be auto-approved`}</InfoText>
      ) : (
        <InfoText>{t`Changes to data on this template require approval`}</InfoText>
      )}
    </Container>
  )
}
